import styled from "styled-components";

export const Container = styled.div`
    padding: 0;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 990px) {
        padding: 0;
    }

    .historico {
        margin-top: 24px;
        padding: 0;
        width: 100%;
        box-sizing: border-box;

        @media (max-width: 990px) {
            margin-top: 24px;
            padding: 0;
        }
    }
`;
